import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@js/modules/translations';

import {Waypoint} from 'react-waypoint';

import LazyLoader from '../../theme/lazyLoader';

import {
    spyTrackClick
} from '@js/actions';


const _handleWaypointEnter = (userId, articleId) => spyTrackClick('blog/article', articleId, 'user', userId);

const _handleArticleClick = (userId, articleId) => spyTrackClick('blog/article', articleId, 'user', userId);

function BlogArticleSample({
                               article,
                               isCol = false
                           }) {
    return (
        <div className="blog-article-item">
            <Waypoint onEnter={_handleWaypointEnter.bind(null, article.user.id, article.id)}/>
            <div className="blog-article-sample">
                {
                    !!article.picture &&
                    <figure>
                        <LazyLoader loadOnMount={window.seoMode}
                                    height={260}
                                    once={true}
                                    offset={200}>
                            <img className="img-helper"
                                 src={article.picture}
                                 alt={I18n.t('js.blog.common.picture')}/>
                        </LazyLoader>

                        <a className="link-to-article"
                           href={article.link}
                           onClick={_handleArticleClick.bind(null, article.user.id, article.id)}/>

                        <figcaption>
                            <div className="icon-animation">
                            <span className="material-icons"
                                  data-icon="reply"
                                  aria-hidden="true"/>
                            </div>
                        </figcaption>
                    </figure>
                }

                <div className="blog-article-content">
                    <div className="row">
                        <div className="col s12">
                            {
                                !isCol &&
                                <div className="blog-article-date">
                                <span className="day">
                                    {article.dateShort[0]}
                                </span>

                                    <span className="month">
                                        {article.dateShort[1]}
                                    </span>
                                </div>
                            }

                            <div className="blog-article-title">
                                <a href={article.link}
                                   onClick={_handleArticleClick.bind(this, article.user.id, article.id)}>
                                    <h2 className="title">
                                        {article.title}
                                    </h2>
                                </a>

                                {
                                    !isCol &&
                                    <div className="blog-article-info">
                                    <span className="blog-article-author">
                                        {I18n.t('js.blog.common.user')}
                                        <a className="blog-article-author-link"
                                           href={article.user.link}>
                                            {article.user.pseudo}
                                        </a>
                                    </span>

                                        <span className="blog-article-info-sep">|</span>

                                        <span className="blog-categories">
                                            <a className="blog-article-comment-link"
                                               href={`${article.link}#comments`}>
                                                {I18n.t('js.blog.common.comment_counts', {count: article.commentsCount})}
                                            </a>
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="col s12">
                            <div className="blog-article-body">
                                <div dangerouslySetInnerHTML={{__html: article.body}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

BlogArticleSample.propTypes = {
    article: PropTypes.object.isRequired,
    isCol: PropTypes.bool
};

export default React.memo(BlogArticleSample);
